import { RetailerLocationEndpoint } from "@api/endpoints";
import { Client } from "./Client";
import { QueryUtil } from '@/utilities/Query';

export class RetailerLocationApi {
  static list (
    query: RetailerLocationEndpoint.List.Query,
  ): Promise<RetailerLocationEndpoint.List.Response> {
    const queryString = QueryUtil.stringify(query);
    return Client(`location?${queryString}`);
  }
}
